// Lib
import React from 'react';
import { UseSheetReturnType } from '../../../mobile/structural/sheet/hooks/useSheet';
import { Sheet } from '../../../mobile/structural/sheet/Sheet';
import Thread from '../Thread';
import { MNComment } from '../../../../common/comments/commentTypes';
import { pluralise } from '../../../../common/utils/stringUtil';

// Styles
import './CommentThreadSheet.scss';

interface CommentThreadSheetContentProps {
    elementId: string;
    currentUserId: string;
    commentList: MNComment[];
}

const CommentThreadSheetContents: React.FC<CommentThreadSheetContentProps> = (props) => {
    const { elementId, currentUserId, commentList } = props;

    return <Thread elementId={elementId} currentUserId={currentUserId} commentList={commentList} />;
};

interface CommentThreadSheetProps extends CommentThreadSheetContentProps {
    closePopup: () => void;
    sheetProps: UseSheetReturnType;
}

const CommentThreadSheet: React.FC<CommentThreadSheetProps> = (props) => {
    const { sheetProps, closePopup, elementId, currentUserId, commentList } = props;

    return (
        <Sheet className="CommentThreadSheet" {...sheetProps} defaultSnapPoint={1} snapPoints={[1]}>
            <Sheet.Overlay />
            <Sheet.Panel>
                <Sheet.Header>
                    <Sheet.Heading>
                        {commentList.length}&nbsp;
                        {pluralise('comment', commentList.length)}
                    </Sheet.Heading>
                    <Sheet.DoneButton onClick={closePopup} />
                </Sheet.Header>
                <Sheet.Content>
                    <CommentThreadSheetContents
                        elementId={elementId}
                        currentUserId={currentUserId}
                        commentList={commentList}
                    />
                </Sheet.Content>
            </Sheet.Panel>
        </Sheet>
    );
};

export default CommentThreadSheet;
